$(document).on("click", ".openpopup", function(event) {
  event.stopPropagation(); // Prevents click events from propagating to parent elements
  var popupclass = $(this).attr("data-popup");
  var $popup = $(".popover-panel."+popupclass);
  
  if ($popup.hasClass("open")) {
    $popup.removeClass("open");
  } else {
    $(".popover-panel").removeClass("open");
    $popup.addClass("open");
  }
});

// Click event handler for the document
$(document).click(function(event) {
  var target = $(event.target);
  // Check if the clicked element does not have the popover-panel class or openpopup class
  if (!target.closest('.popover-panel').length) {
    $(".popover-panel").removeClass("open");
  }
});

$(document).on("click", ".delivery_close", function(event) {
  event.stopPropagation(); // Prevents click events from propagating to parent elements
  var $popup = $(this).parents(".popover-panel");
  if ($popup.hasClass("open")) {
    $popup.removeClass("open");
  }
});

$(document).on("click", ".openanimation_pop", function(event) {
  event.stopPropagation(); // Prevents click events from propagating to parent elements
  $(".for_overlay").addClass("change_backcolor")
  var popupclass = $(this).attr("data-popup");
  var $popup = $(".animation_popup."+popupclass);
  
  if ($popup.hasClass("open_animation")) {
    $popup.removeClass("open_animation");
  } else {
    $(".animation_popup").removeClass("open_animation");
    $popup.addClass("open_animation");
  }
  scrollitems();
  tooltipcustom();
});


$(document).on("click", ".animation_close", function(event) {
  event.stopPropagation(); // Prevents click events from propagating to parent elements
  $(".for_overlay").removeClass("change_backcolor")
  var $popup = $(this).parents(".animation_popup");
  if ($popup.hasClass("open_animation")) {
    $popup.removeClass("open_animation");
  }
});

$(document).on("click", ".readmore", function() {
  $(".fulldes").show();
  $(".shortdes").hide();
});
function scrollitems() {
  const sliders = document.querySelectorAll('.drag_items');

  sliders.forEach(slider => {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
    });
  });
}

// Tooltip Function
function tooltipcustom(){
 $('.drag_inner_items').each(function() {
    var dataname = $(this).attr("data-name");
    var words = dataname.toLowerCase().split(' ');
    var capitalizedWords = words.map(function(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
    });
   var capitalizedName = capitalizedWords.join(' ');
    tippy(this, {
      content: capitalizedName,
      animation: 'scale',
      theme: 'light',
      placement: 'top',
    });
  });
  $('.tool_tip_custom').each(function() {
    var dataname = $(this).attr("data-name");
    tippy(this, {
      content: dataname,
      animation: 'scale',
      theme: 'light',
      placement: 'top',
    });
  });
$('.legs_form-group').each(function() {
    var dataname = $(this).attr("data-name");
    tippy(this, {
      content: dataname,
      animation: 'scale',
      theme: 'light',
      placement: 'top',
    });
  });
$('.hint_trigger').each(function() {
    var dataname = $(this).attr("data-name");
    tippy(this, {
      content: dataname,
      animation: 'scale',
      theme: 'light',
      placement: 'top',
    });
  });  
}

// Initialize Tippy.js tooltip
$(document).ready(function() {
  var swtachhtml = $(".main_option").html();
  $(".swatch_inner_popup").html(swtachhtml);
  var legshtml = $(".legs_swt_data").html();
  $(".legs_pop_swatch").html(legshtml);
  scrollitems();
  tooltipcustom();
});

/* Code For Image Change In Popup */
$(document).ready(function() {
 $('.selectopt:first').trigger('click');
  var selectval = $(".selectopt").val();
  $(".mainvarvalue").html(selectval);
  $(".selct_swtchval").html(selectval);
  $(document).on("click", ".selectopt", function() {
    var checkval = $(this).val();
    console.log($(this).attr("name"));
    var origval = $(this).attr("data-origval");
    var swatchimage = $(this).attr("data-image");
    var popclass = $(this).parents(".main_option").attr("data-mainoptions");
    $("."+popclass+" .img_div_contain").css("background-image", "url('"+swatchimage+"')");
    $("."+popclass+" input[value='"+checkval+"']").prop('checked', true);
    $(".mainvarvalue").html(checkval);
    $("."+popclass+" .selct_swtchval").html(checkval);
    $("#desn_your").attr("value",origval);
  });
  $(document).on("click", ".main_swatch_popup .selectopt", function() {
     var checkval = $(this).val();
    $(".main_option input[value='"+checkval+"']").trigger("click");
  });
});

/* Code For Image Change In Popup */
$(document).ready(function() {
 $('.legs_radio:first').trigger('click');
  var selectval = $(".legs_radio").val();
  var origval = $(".legs_radio:checked").attr("data-origval");
  $(".legs_varvalue").html(selectval);
  $("#legscolor").attr("name","properties[Legs Color]");
  $("#legscolor").attr("value",origval);
  $(document).on("click", ".legs_radio", function() {
    var checkval = $(this).val();
    $(".main_swatch_main_inner input[value='"+checkval+"']").trigger("click");
    var origval = $(this).attr("data-origval");
    var swatchimage = $(this).attr("data-image");
    var popclass = $(this).parents(".legs_main").attr("data-mainoptions");
    $("."+popclass+" .img_div_contain").css("background-image", "url('"+swatchimage+"')");
    $("."+popclass+" input[value='"+checkval+"']").prop('checked', true);
    $(".legs_varvalue").html(checkval);
    $("#legscolor").attr("name","properties[Legs Color]");
    $("#legscolor").attr("value",origval);
    var checkdytitle = $('.dyotitle').length
    var checkdes = $('.dyo_desc').length
    if($(".stdcolor").is(":checked")){
      if(checkdytitle > 0){
      $(".maintitle_pr").show();
      $('.dyotitle').hide();
     }
     if(checkdes > 0){
      $('.dyo_desc').hide();
      $('.maindesc').show();
     }
    }
    else{
      if(checkdytitle > 0){
      $(".maintitle_pr").hide();
      $('.dyotitle').show();
     }
     if(checkdes > 0){
      $('.dyo_desc').show();
      $('.maindesc').hide();
     }
    }
    // Lead-time text depends on the selected legs variant's stock, not just
    // the fabric type — handled centrally (defined in product-redesign.liquid).
    if (window.updateLeadTimeDisplay) {
      window.updateLeadTimeDisplay();
    }
  });
  $(document).on("click", ".legs_pop_swatch .legs_radio", function() {
     var checkval = $(this).val();
    $(".legs_main input[value='"+checkval+"']").trigger("click");
  });
});

/* Code For Add To Cart In Popup */
$(document).on("click", ".popup_addtocart", function() {
  $(".product-form--atc-button").trigger("click");
});
/* code for add variant id for default variants products */
$(document).ready(function() {
  setTimeout(function(){
  var checkval = $(".checkvarid").val();
  $(".addvariant_id").attr("variant",checkval);
  },500);
});
const loadColorFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const color = params.get('color');
    if (!color) return;

    const input = document.querySelector(`[data-origval="${color}"]`);
    if (!input) return;

    const interval = setInterval(() => {
      if (input.checked) {
        clearInterval(interval);
        return;
      }

      input.click();
    }, 150);
};

window.addEventListener('load', loadColorFromUrl);
